import { useEffect, useState } from 'react';

import { useUpdateProjectContact } from '@/features/projects/project-details/hooks/use-update-project-contact';

type UseContactEditParams = {
  projectId: number;
  initialContact: string | null;
  field: 'main_contact' | 'contractor_contact' | 'client_contact';
  isOpen: boolean;
  onClose: () => void;
};

export function useContactEdit({
  projectId,
  initialContact,
  field,
  isOpen,
  onClose,
}: UseContactEditParams) {
  const [contact, setContact] = useState<string>(initialContact || '');
  const mutation = useUpdateProjectContact();

  // Sync contact state with initialContact when dialog opens or initialContact changes
  useEffect(() => {
    if (isOpen) {
      setContact(initialContact || '');
    }
  }, [isOpen, initialContact]);

  const handleSave = () => {
    const trimmed = contact.trim();
    if (trimmed && trimmed !== initialContact) {
      mutation.mutate({ projectId, contact: trimmed, field });
    }
    onClose();
  };

  const handleClose = () => {
    setContact(initialContact || '');
    onClose();
  };

  return {
    contact,
    setContact,
    handleSave,
    handleClose,
    isLoading: mutation.isPending,
    error: mutation.error,
  };
}
